import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../../../../../../../../features/components/Form/MultiSelectBox'
import SubAllocationMultiFieldItem from '../../SubAllocationMultiFieldItem'

import { getLoadOptionsHandlerCursorPagination } from '../../../../../../../../../../../../../features/helpers/componentsHelpers'

import { getGoogleAdManagerPlacementsService } from '../../../../../../../../../../../../../modules/services/rights'
import { getOnsiteRatesSelector } from '../../../../../../../../../../../../../modules/selectors/googleAdManager'
import { selfAccountSelector } from '../../../../../../../../../../../../../modules/selectors/selfAccounts'

import { AD_PLACEMENTS, IS_SUB_ALLOCATION } from '../../../../../fields'
import { CPC, CPM, VIEWABLE_CPM } from '../../fields'
import { GAM_NETWORK_CODE } from '../../../../fields'

import useSelectedItemsTableStyles from '../../styles'

const AdPlacementsSelect = ({ formik }) => {
  const { values, setFieldValue } = formik

  const selectedItemsTableClasses = useSelectedItemsTableStyles()

  const onsiteRates = useSelector(getOnsiteRatesSelector)
  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const formatOptions = useCallback(options => {
    return options.map(option => ({
      ...option,
      value: option.id,
      label: option.name
    }))
  }, [])

  const selectAdPlacementsHandler = useCallback(
    selectedValues => {
      const formattedValues = selectedValues.map(value => {
        const previouslySelectedPlacement = values[AD_PLACEMENTS].find(item => {
          return item.id === value.id
        })

        return {
          ...value,
          [CPM]:
            previouslySelectedPlacement?.[CPM] ||
            onsiteRates?.find(rate => rate.inventory_id === value.id)?.prices?.[CPM] ||
            0,
          [CPC]:
            previouslySelectedPlacement?.[CPC] ||
            onsiteRates?.find(rate => rate.inventory_id === value.id)?.prices?.[CPC] ||
            0,
          [VIEWABLE_CPM]:
            previouslySelectedPlacement?.[VIEWABLE_CPM] ||
            onsiteRates?.find(rate => rate.inventory_id === value.id)?.prices?.[VIEWABLE_CPM] ||
            0
        }
      })
      setFieldValue(AD_PLACEMENTS, formattedValues)
    },
    [onsiteRates, setFieldValue, values]
  )

  const loadOptions = useMemo(() => {
    return getLoadOptionsHandlerCursorPagination({
      getOptionsService: getGoogleAdManagerPlacementsService,
      params: {
        network_code: gamNetworkCode
      },
      formatOptions: formatOptions
    })
  }, [formatOptions, gamNetworkCode])

  return (
    <MultiSelectBox
      loadOptions={loadOptions}
      value={values[AD_PLACEMENTS]}
      name={AD_PLACEMENTS}
      setFieldValue={setFieldValue}
      className={selectedItemsTableClasses.field}
      placeholder="Add a placement"
      CustomMultiFieldItem={values[IS_SUB_ALLOCATION] ? <SubAllocationMultiFieldItem formik={formik} /> : null}
      onValueChangeCallback={selectAdPlacementsHandler}
    />
  )
}

export default AdPlacementsSelect
